import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const AdminMonthlyRentalsListView = lazy(() =>
	import('./components/views/AdminMonthlyRentalsListView').then((module) => ({
		default: module.AdminMonthlyRentalsListView
	}))
);

/**
 * The Monthly Rentals routes.
 */
const monthlyRentalsRoutes: FuseRouteItemType[] = [
	{
		path: 'monthly-rentals',
		element: <AdminMonthlyRentalsListView />
	}
];

export default monthlyRentalsRoutes;
